import React, { useEffect, useMemo, useState } from 'react';

function useIsInViewport(ref: React.MutableRefObject<HTMLElement>): boolean {
  const [isIntersecting, setIsIntersecting] = useState(false);

  const observer = useMemo(
    () => new IntersectionObserver(
      ([entry]) => setIsIntersecting(entry.isIntersecting),
    ),
    [],
  );

  useEffect(() => {
    if (ref.current) {
      observer.observe(ref.current);

      return () => {
        observer.disconnect();
      };
    }
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    return () => {};
  }, [ref, observer]);

  return isIntersecting;
}

export default useIsInViewport;
